import React from 'react';
import Media from 'react-media';

export default props => <Media query={{ maxWidth: '767px' }} {...props} />;
